/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Type_RpeInputs */

const fr_load_type_rpe = /** @type {(inputs: Load_Type_RpeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPE`)
};

/**

* @param {Load_Type_RpeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const load_type_rpe = /** @type {((inputs?: Load_Type_RpeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Type_RpeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_load_type_rpe(inputs)
});